<page-header
        icon="{{['SEO', 'PAGES'] | monIcons }}"
    header="{{'Issues by Page' | translate}}">
</page-header>
<mon-tabs
        (onSearch)="onSearch($event)"
        [search]="search"
        [minSearchLength]="1"
        [showSearch]="true"
        [showFiltersBtn]="showFilters"
        [(isFiltersOpen)]="isFiltersOpen">
        <csv-export-button [exports]="exports"></csv-export-button>
</mon-tabs>
<div class="card panel-monsido-card">
    <div class="card-body">
        <div class="row">
            <div class="col-md-48 col-lg-48 col-48">
                <pages-table
                        [showNotifications]="['seo']"
                        [progress]="promise"
                        [pages]="pages"
                        [currentSort]="currentSort"
                        (onPageChange)="onPageChange($event)"
                        (onPageSort)="onSortPage($event.direction, $event.by)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        [(isFiltersOpen)]="isFiltersOpen"
                        (onFiltersChanges)="onFiltersChanges($event)"
                        [target]="'page-details-section-seo'">
                </pages-table>
            </div>
        </div>
    </div>
</div>
